import { Pipe, PipeTransform } from '@angular/core';
import { Common } from '../lib/common-methods';

@Pipe({
  name: 'unknownSource',
})
export class UnknownSourcePipe implements PipeTransform {

  transform(sourceType: string | undefined, ...args: unknown[]): unknown {

    if (Common.isNullOrEmpty(sourceType)) {
      return '';
    }

    return (sourceType as string)[0].toUpperCase();
  }

}
